import React from 'react'
import styles from './Header.module.scss'
import { Grid, Typography } from '@mui/material'
import logo from '../../asserst/logo/Logo.svg'
import { useNavigate } from 'react-router-dom'

const Header = () => {
    const navigation = useNavigate()
    const data = [
        { label: "HOME", path: "/" },
        { label: "ABOUT", path: "/about" },
        { label: "SERVICES", path: "/service" },
        { label: "PORTFOLIO", path: "/portfolio" },
        { label: "CAREER", path: "/career" },
        { label: "CONTACT US", path: "/contact" }
    ]

    return (
        <Grid container className={styles.headerContainer}>
            {/* Logo */}
            <Grid item className={styles.logoBox}>
                <img src={logo} alt='logo' onClick={() => navigation("/")} />
            </Grid>

            {/* Labels */}
            <Grid item className={styles.menuBox}>
                {data.map((item, index) => (
                    <Typography key={index} onClick={() => navigation(item.path)}>
                        {item.label}
                    </Typography>
                ))}
            </Grid>
        </Grid>
    )
}

export default Header
